import {
  TableSkeleton,
  FormSkeleton,
  FilterSkeleton,
  CardSkeleton,
  ListSkeleton,
  DetailsSkeleton,
  InfoListSkeleton,
} from './components'
import { SkeletonProps, SkeletonVariant } from './types'

const SkeletonFactory: React.FC<SkeletonProps> = props => {
  const { variant } = props

  switch (variant) {
    case SkeletonVariant.Card:
      return <CardSkeleton />
    case SkeletonVariant.CardGroup:
      return <CardSkeleton variant='group' />
    case SkeletonVariant.Form:
      return <FormSkeleton />
    case SkeletonVariant.Filter:
      return <FilterSkeleton />
    case SkeletonVariant.List:
      return <ListSkeleton />
    case SkeletonVariant.Details:
      return <DetailsSkeleton />
    case SkeletonVariant.InfoList:
      return <InfoListSkeleton />
    case SkeletonVariant.Table:
    default:
      return <TableSkeleton />
  }
}

export default SkeletonFactory
